import React, { useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { Button } from 'react-bootstrap'
import { GET_DOWNLOAD_LINK } from '../Vouchers/gql'
import { getFileExtension } from '../../utils/utils'
import FilePreviewModal from '../modals/FilePreviewModal'

type FilePreviewButtonProps = {
  fileId: string
  fileName?: string
  children?: React.ReactNode
}

const FilePreviewButton: React.FC<FilePreviewButtonProps> = ({
  fileId,
  fileName,
  children,
}) => {
  const [show, setShow] = useState(false)
  const [fileUrl, setFileUrl] = useState<string>('')

  const [getFileLink] = useLazyQuery(GET_DOWNLOAD_LINK, {
    onCompleted: (data) => {
      const signedLink = data.signedDownloadLink.signedLink
      setFileUrl(signedLink)
      setShow(true)
    },
  })

  const handleClick = () => {
    getFileLink({ variables: { id: fileId } })
  }

  const handleClose = () => setShow(false)

  const filename = fileName || fileId
  const fileType = getFileExtension(filename) === 'pdf' ? 'pdf' : 'image'

  return (
    <>
      <Button variant="link" onClick={handleClick} className="p-0">
        {children ?? 'Preview'}
      </Button>

      <FilePreviewModal
        src={fileUrl}
        type={fileType}
        show={show}
        onClose={handleClose}
      />
    </>
  )
}

export default FilePreviewButton
